import afrikad_logo_png from '$assets/afrikad-logo-w220.png';
import articles_svg from '$assets/services/articles.svg';
import avis_clients_svg from '$assets/services/avis-clients.svg';
import campagnes_emails_svg from '$assets/services/campagnes-emails.svg';
import devis_centralises_svg from '$assets/services/devis-centralises.svg';
import entreprises_verifiees_svg from '$assets/services/entreprises-verifiees.svg';
import messagerie_instantanee_svg from '$assets/services/messagerie-instantanee.svg';
import prise_de_rendez_vous_en_ligne_svg from '$assets/services/prise-de-rendez-vous-en-ligne.svg';
import reseau_social_pro_svg from '$assets/services/reseau-social-pro.svg';
import visibilite_digitale_svg from '$assets/services/visibilite-digitale.svg';
import type { UrlHelper } from '$lib/UrlHelper';

export type ServiceKey =
    | 'services_internet'
    | 'services_visibilite_digitale'
    | 'services_devis_centralises'
    | 'services_inbox'
    | 'services_avis_clients'
    | 'services_campagnes_emails'
    | 'services_afrikad'
    | 'services_shopping'
    | 'services_rdv_en_ligne'
    | 'services_charte_verification_entreprise'
    | 'services_reseau_social_pro'
    | 'services_land_entreprises_visibilite_digitale'
    | 'services_land_membres_emploi';

export type Service = {
    title: string;
    mobileTitle?: string;
    navbarTitle?: string;
    image: string;
    description?: string;
    link: 'cmsCountry' | ((urlHelper: UrlHelper) => string);
    sveltekitReload: boolean;
};

export const services: readonly Service[] = [
    {
        title: 'Visibilité digitale',
        image: visibilite_digitale_svg,
        description:
            'Bénéficiez d’une présence efficace et d’une bonne image sur internet',
        link: (urlHelper) => urlHelper.servicePage('services_visibilite_digitale'),
        sveltekitReload: false,
    },
    {
        title: 'Devis centralisés',
        image: devis_centralises_svg,
        description: 'Obtenez des demandes de devis de la part de prospects qualifiés',
        link: (urlHelper) => urlHelper.servicePage('services_devis_centralises'),
        sveltekitReload: false,
    },
    {
        title: 'Messagerie instantanée',
        image: messagerie_instantanee_svg,
        description: 'Discutez en direct avec vos prospects et contacts',
        link: (urlHelper) => urlHelper.servicePage('services_inbox'),
        sveltekitReload: false,
    },
    {
        title: 'Avis clients',
        image: avis_clients_svg,
        description: 'Renforcez la confiance de vos futurs clients',
        link: (urlHelper) => urlHelper.servicePage('services_avis_clients'),
        sveltekitReload: false,
    },
    {
        title: 'Campagnes Emails et SMS',
        image: campagnes_emails_svg,
        description: 'Touchez directement jusqu’à 600.000 contacts ciblés et qualifiés',
        link: (urlHelper) => urlHelper.servicePage('services_campagnes_emails'),
        sveltekitReload: false,
    },
    {
        title: 'Afrikad.com : notre plateforme de sites éditeurs',
        mobileTitle: 'Afrikad.com : régie publicitaire',
        navbarTitle: 'Régie publicitaire',
        image: afrikad_logo_png,
        description:
            'Afrikad vous offre l’audience de plus de 150 sites internet locaux au service de votre communication',
        link: (urlHelper) => urlHelper.servicePage('services_afrikad'),
        sveltekitReload: false,
    },
    {
        title: 'Présentez vos produits à vendre',
        navbarTitle: 'Vos produits à vendre',
        image: articles_svg,
        description:
            'Service dédié à la présentation de vos produits ou services : photos, descriptifs, prix…',
        link: (urlHelper) => urlHelper.servicePage('services_shopping'),
        sveltekitReload: false,
    },
    {
        title: 'Prise de rendez-vous en ligne',
        navbarTitle: 'Rendez-vous en ligne',
        image: prise_de_rendez_vous_en_ligne_svg,
        description:
            'Vos prospects peuvent vous demander un rendez-vous directement depuis Go Africa Online',
        link: (urlHelper) => urlHelper.servicePage('services_rdv_en_ligne'),
        sveltekitReload: false,
    },
    {
        title: 'Articles',
        image: articles_svg,
        link: 'cmsCountry',
        sveltekitReload: true,
    },
    {
        title: 'Entreprises vérifiées',
        image: entreprises_verifiees_svg,
        link: (urlHelper) =>
            urlHelper.servicePage('services_charte_verification_entreprise'),
        sveltekitReload: false,
    },
    {
        title: 'Réseau social professionnel',
        image: reseau_social_pro_svg,
        description:
            "Développez votre communauté d'abonnés et l'impact de vos publications",
        link: (urlHelper) => urlHelper.servicePage('services_reseau_social_pro'),
        sveltekitReload: false,
    },
] as const;
